import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Clock } from "lucide-react";
import { TimelineTab } from "./tabs/TimelineTab";
import { TIMELINE_LIMIT } from "@shared/utils/constants";

interface ActivitySidebarProps {
  entityId: string;
  remoteUtilityId: number;
  actionType: string;
}

export function ActivitySidebar({
  entityId,
  remoteUtilityId,
  actionType,
}: ActivitySidebarProps) {
  return (
    <Card >
      <CardHeader className="pb-1 px-0 pt-0">
        <CardTitle className="text-sm font-semibold  tracking-wider text-muted-foreground flex items-center gap-2 mt-4">
          <Clock className="h-4 w-4" />
          Recent Activities
        </CardTitle>
      </CardHeader>
      <CardContent className="px-0 border-none shadow-none bg-transparent">
        <div className="max-h-[600px] overflow-y-auto pr-2 scrollbar-thin">
          <TimelineTab
            entityId={entityId}
            remoteUtilityId={remoteUtilityId}
            actionType={actionType}
            limit={TIMELINE_LIMIT}
          />
        </div>
      </CardContent>
    </Card>
  );
}
